
import {styled} from '@mui/material/styles';
import Container from '@mui/material/Container';

import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    Card,
    FlexBLock,
    WhiteSpaceVertical,
    Dialog,
    LoadingBlock,
    Tips
} from '../../components';

import {
    useSendCVC,
    useSendCVCD,
    useSendAIToken
} from '../../hook/ma/useNode'

function SendCVCCard() {
    const {
        button,
        amountInput
    } = useSendCVC()
    const disable = amountInput.value > 100
    return (
        <Card>
            <TextL block>CVC</TextL>
            <TextM>address amounts</TextM>
            <Input input={amountInput}/>
            <Button disabled={disable} type='b' style={{width: '100%'}} {...button} />
        </Card>
    )
}

function SendCVCDCard() {
    const {
        button,
        amountInput
    } = useSendCVCD()
    const disable = amountInput.value > 100
    return (
        <Card>
            <TextL block>CVCD</TextL>
            <TextM>address amounts</TextM>
            <Input input={amountInput}/>
            <Button disabled={disable} type='b' style={{width: '100%'}} {...button} />
        </Card>
    )
}


function SendAITokenCard() {
    const {
        button,
        amountInput
    } = useSendAIToken()
    const disable = amountInput.value > 100
    return (
        <Card>
            <TextL block>AI Token</TextL>
            <TextM>address amounts</TextM>
            <Input input={amountInput}/>
            <Button disabled={disable} type='b' style={{width: '100%'}} {...button} />
        </Card>
    )
}


function SendCVC() {
    return (
        <Container maxWidth="sm">
            <WhiteSpaceVertical height={20} />
            <SendCVCCard />
            <WhiteSpace />
            <SendCVCDCard />
            <WhiteSpace />
            <SendAITokenCard />
        </Container>
    )
}

export default SendCVC